import React from "react";
import { useHistory } from "react-router-dom";
import "../../../assets/css/style.css";
import CV1 from "../../../assets/images/resume/CV1.png";
import CV2 from "../../../assets/images/resume/CV2.png";
import CV3 from "../../../assets/images/resume/CV3.png";
import CV4 from "../../../assets/images/resume/CV4.png";
import CV5 from "../../../assets/images/resume/CV5.jpg";
import CV6 from "../../../assets/images/resume/CV6.jpg";
import CV7 from "../../../assets/images/resume/CV7.png";

// Templates from Redux state
const templates = [
  { id: 1, name: "Template 1" },
  { id: 2, name: "Template 2" },
  { id: 3, name: "Template 3" },
  { id: 4, name: "Template 4" },
  { id: 5, name: "Template 5" },
  { id: 6, name: "Template 6" },
  { id: 7, name: "Template 7" },
];

const CandidateDownLoadResume = ({ candidateId }) => {
  const history = useHistory();

  const openTemplate = (templateId) => {
    var url = `/candidates/previewResumeTemplate/${templateId}`;
    window.open(url, '_blank').focus();
  };

  return (
    <React.Fragment>
      <div className="col-lg-8">
        <div className="row">
          <div className="col-xl-12">
            <div className="bg-light-3 p-4">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title">
                    <h2 className="title">
                      <span>Télécharger mon CV</span>
                    </h2>
                  </div>
                </div>
              </div>
              <div _lpchecked="1">
                <div className="row">
                  {[CV1, CV2, CV3, CV4, CV5, CV6, CV7].map(
                    (template, index) => (
                      <div
                        className="col-12 col-sm-6 col-md-6 mb-4"
                        key={index}
                      >
                        <div className="cv-template">
                          <img
                            src={template}
                            alt={`Template ${index + 1}`}
                            className="img-fluid"
                          />
                          <div className="overlay d-flex justify-content-center align-items-center">
                            <button
                              className="btn btn-primary"
                              onClick={() => openTemplate(templates[index].id)}
                            >
                              Utiliser ce template
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CandidateDownLoadResume;
